import { Button, Card, Form, Input, Select, Spin } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/SubList";

class Create extends React.Component {

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match && match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match && match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
        this.props.form.resetFields();
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form, activitySerialNo } = this.props;
    let subMaster = (this.props && this.props.subMaster) || false;

    // console.log(filters)

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {
              (title === 'EDIT') && <Form.Item key={'activitySerialNo'} label={'Activity Serial No'}>
                {getFieldDecorator('activitySerialNo', {
                  rules: [{ required: false, message: `activitySerialNo is required!` }],
                  initialValue: activitySerialNo ? activitySerialNo : ((data && data.activitySerialNo) || ''),
                })(<Input disabled />)
                }
              </Form.Item>
            }

            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && filters[item].schema && title !== 'EDIT') {
                return <SubList key={item} item={filters[item]} form={form} hideAddButton={true} data={data && data[item]} title={title} subMaster={subMaster} resource={resource} />
              } else {
                if (item === 'activityType') {
                  return <Form.Item key={item} label={'Activity Type'}>
                    {getFieldDecorator('activityType', {
                      rules: [{ required: false, message: `Activity Type is required!` }],
                      initialValue: data && data.activityType,
                    })(<Select disabled={title === 'EDIT'} style={{ width: '100%' }} placeholder="Please select">
                      {filters['activityType'] && filters['activityType'].data &&
                        filters['activityType'].data.data &&
                        filters['activityType'].data.data
                          .filter(item => item.name && item.name.toLowerCase() !== 'autojc')
                          .map(item => <Select.Option key={item._id}
                            value={item._id}>{item.name}</Select.Option>)}
                    </Select>)}
                  </Form.Item>
                }
                else if (item !== 'activitySerialNo' && item !== 'status') {
                  return getFormFieldByType(filters, item, getFieldDecorator, data, { title: title, resource, subMaster: subMaster })
                }
              }
            })}

            {
              title !== 'CREATE' && <Form.Item key={'status'} label={'Status'}>
                {getFieldDecorator('status', {
                  rules: [{ required: false, message: `Status is required!` }],
                  initialValue: data && data.status,
                })(<Select
                  disabled
                  style={{ width: '100%' }}
                  placeholder="Please select"
                >
                  {filters['status'] && filters['status'].options.enum.map(item => <Select.Option key={item}
                    value={item}>{item}</Select.Option>)}
                </Select>)
                }
              </Form.Item>
            }

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
